const isEnabled = process.env.NODE_ENV !== 'production';

const logger = {
  log: (...args) => {
    if (isEnabled) console.log(...args);
  },
  warn: (...args) => {
    if (isEnabled) console.warn(...args);
  },
  error: (...args) => {
    if (isEnabled) console.error(...args);
  },
};

export default logger;
